import { useMutation } from '@apollo/react-hooks';
import { setPinStateMutation } from 'services/apollo/mutations';
import { GroupPinnedFeedQuery, GroupSummaryQuery } from 'services';
import produce from 'immer';
import { Logger } from 'services';
import { useFeatureFlagState } from 'context';

export function useSetPinState(node: any, pin: boolean, targetId: any, pins: any) {
  const { groupsFeatureFlag } = useFeatureFlagState();

  const optimisticPinsList = [...pins];

  const index = optimisticPinsList.indexOf(targetId);

  pin ? optimisticPinsList.push(targetId) : optimisticPinsList.splice(index, 1);

  return useMutation(setPinStateMutation, {
    variables: {
      id: node.id,
      pin,
      targetId,
    },
    optimisticResponse: {
      __typename: 'Mutation',
      setPinState: {
        __typename: 'SetPinState',
        node: {
          __typename: 'Node',
          id: node.id,
          pins: optimisticPinsList,
        },
      },
    },
    update(cache) {
      // Update the group header to correct number of pins
      const readQueryResult: any = cache.readQuery({
        query: GroupSummaryQuery,
        variables: {
          groupId: targetId,
        },
      });

      try {
        cache.writeQuery({
          query: GroupSummaryQuery,
          variables: {
            groupId: targetId,
          },
          data: produce(readQueryResult, (draft: any) => {
            draft.groupById.pinnedNodes.pageInfo.total = pin
              ? draft.groupById.pinnedNodes.pageInfo.total + 1
              : draft.groupById.pinnedNodes.pageInfo.total - 1;
          }),
        });
      } catch (err) {
        Logger.log(err);
      }

      // Update pinned tab to have the correct nodes
      const readQueryResultPinned: any = cache.readQuery({
        query: GroupPinnedFeedQuery,
        variables: {
          groupId: targetId,
          includeGroups: groupsFeatureFlag,
          first: 10,
          cursor: '',
        },
      });

      try {
        cache.writeQuery({
          query: GroupPinnedFeedQuery,
          variables: {
            groupId: targetId,
            includeGroups: groupsFeatureFlag,
            first: 10,
            cursor: '',
          },
          data: produce(readQueryResultPinned, (draft: any) => {
            if (pin === false) {
              // Removes the pin from the node
              const index = draft.groupById.pinnedNodes.nodes.findIndex(
                (cachedNode: any) => cachedNode.id === node.id
              );
              if (index !== -1) draft.groupById.pinnedNodes.nodes.splice(index, 1);
            } else {
              // Adds pin to the node
              const newNode = { ...node };
              newNode.pins = newNode.pins.concat(targetId);
              draft.groupById.pinnedNodes.nodes.unshift(newNode);
            }
          }),
        });
      } catch (err) {
        Logger.log(err);
      }
    },
  });
}
